import { useEffect, useState } from 'react'
import useAuth from '../../../../hooks/useAuth'
import usePluginSpace from '../../../../hooks/usePluginSpace'

export const useSellerQueuePluginspaceId = () => {
  const { loginInfo } = useAuth()
  const { getPluginSpace } = usePluginSpace()
  const [pluginspaceId, setPluginspaceId] = useState<number>(
    Number(loginInfo?.pluginspaceId) || 0
  )

  useEffect(() => {
    const idFromLogin = Number(loginInfo?.pluginspaceId) || 0
    if (idFromLogin > 0) {
      setPluginspaceId(idFromLogin)
    }
  }, [loginInfo?.pluginspaceId])

  useEffect(() => {
    let isMounted = true

    const loadPluginspace = async () => {
      if (Number(loginInfo?.pluginspaceId) > 0) return

      try {
        const pluginspaceData = await getPluginSpace(false, true)
        const resolvedId = Number(pluginspaceData?.id) || 0

        if (isMounted && resolvedId > 0) {
          setPluginspaceId(resolvedId)
        }
      } catch (_) {
        // Keep best known value; realtime setup will retry on subsequent renders.
      }
    }

    loadPluginspace()

    return () => {
      isMounted = false
    }
  }, [getPluginSpace, loginInfo?.pluginspaceId])

  return pluginspaceId
}
